import {
  type DashboardIssueRemoteProject,
  discoverRemoteIssueProjectsAsUser,
  generateJiraLinkCodeAsUser,
} from "../dashboard-client";

export type RemoteIssueProject = DashboardIssueRemoteProject;

export async function fetchRemoteIssueProjects(
  providerId: string,
): Promise<RemoteIssueProject[]> {
  const { data } = await discoverRemoteIssueProjectsAsUser({
    path: { providerId },
  });
  return data.projects;
}

export async function generateJiraLinkCode(): Promise<{ code: string }> {
  const { data } = await generateJiraLinkCodeAsUser();
  return data;
}
